import * as React from 'react';

import { Heading } from '@built/design-system';

import * as styles from './SetupCompleteImaUser.module.scss';
import l10n from '@built/i18n';

/**
 * Renders the final setup step for IMA users
 */
export default class SetupCompleteImaUser extends React.Component<
  SetupCompleteImaUserProps
> {
  render() {
    return (
      <div className={styles.verticalSpacing}>
        <Heading size="xxl">
          {l10n.t('SetupCompleteImaUser:youAreGood', "You're good to go!")}
        </Heading>

        <p className={styles.lead}>
          {l10n.t(
            'SetupCompleteImaUser:thePasswordForYourAccount',
            'The password for your account'
          )}
          <strong>{this.props.email}</strong>
          {l10n.t(
            'SetupCompleteImaUser:wasChangedSuccessfully',
            'was changed successfully, and your account is now more secure. ' +
              'It is now safe to return to the Built Inspector Mobile Application and log in with your new password.'
          )}
        </p>
      </div>
    );
  }
}

export interface SetupCompleteImaUserProps {
  email: string;
}
